import React, { FC, memo } from 'react';
import { Button, Input, Space } from 'udesk-ui';
import ValuePlain from './components/ValuePlain';
import ValueSpecial1 from './components/ValueSpecial1';
import { AddOutlined, IndeterminateCircleOutlined } from '@udesk/icons';
import styled from 'styled-components';
import UdeskLocales from 'UdeskLocales';

const Wrapper = styled.div`
    margin-bottom: 12px;
`;

const Item = styled.div`
    margin-bottom: 4px;
`;

const Action = styled.div``;

export interface ListItem<T = any> {
    key?: string;
    keyType?: 1 | 2;
    value?: T;
}

interface TemplateProps {
    value?: ListItem[];
    onChange?: (value: TemplateProps['value']) => void;
    valueType?: 'plain' | 'special1';
    dataSourceList?: number[];
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange, valueType = 'plain', dataSourceList } = props;
    const onDel = (idx: number) => {
        onChange?.([...(value || []).filter((item, _idx) => idx !== _idx)]);
    };

    const onAdd = () => {
        onChange?.([
            ...(value || []),
            {
                key: undefined,
                value: undefined,
                keyType: 1,
            },
        ]);
    };

    const onKeyChange = (idx: number, v: string) => {
        onChange?.(
            value?.map((item, _idx) => {
                if (idx === _idx) {
                    return {
                        ...item,
                        key: v,
                    };
                } else {
                    return item;
                }
            })
        );
    };

    const onValueChange = (idx: number, v?: ListItem) => {
        onChange?.(
            value?.map((item, _idx) => {
                if (idx === _idx) {
                    return {
                        ...item,
                        keyType: v?.keyType,
                        value: v?.value,
                    };
                } else {
                    return item;
                }
            })
        );
    };

    return (
        <Wrapper>
            {value?.map((item, idx) => {
                return (
                    <Item key={idx}>
                        <Space>
                            <Input
                                value={item.key}
                                onChange={(e) => onKeyChange(idx, e.target.value)}
                                style={{ width: 150 }}
                                placeholder={/* 请输入参数名 */UdeskLocales['current'].pages.semanticIntelligence.externalInterface.detail.components.paramsList.index.pleaseEnterAParameterName}
                            />

                            <span>=</span>

                            {valueType === 'plain' ? (
                                <ValuePlain
                                    value={{ value: item.value }}
                                    onChange={(v) => onValueChange(idx, v)}
                                />
                            ) : valueType === 'special1' ? (
                                <ValueSpecial1
                                    value={{ keyType: item.keyType, value: item.value }}
                                    onChange={(v) => onValueChange(idx, v)}
                                    dataSourceList={dataSourceList}
                                />
                            ) : null}

                            <IndeterminateCircleOutlined onClick={() => onDel(idx)} />
                        </Space>
                    </Item>
                );
            })}

            <Action>
                <Button size="small" type="dashed" onClick={() => onAdd()}>
                    <AddOutlined />{/* 添加接口参数 */}{UdeskLocales['current'].pages.semanticIntelligence.externalInterface.detail.components.paramsList.index.addInterfaceParameters}</Button>
            </Action>
        </Wrapper>
    );
});

export default Template;
